import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js/auto";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import medicGeekApi from "../config/axiosConfig";
import ConsultaForm from "../Forms/Consulta/ConsultaForm";
import "../styles/global.css";
import "../styles/ventanaFlotante.css";
import MedicineSVG from "./../assets/svg/undraw_medicine_b-1-ol.svg";
import TipTap from "../styles/TipTap.css";
import ProRichTextEditor from "../contexts/ProRichTextEditor";

ChartJS.register(BarElement, Tooltip, Legend, CategoryScale, LinearScale);

const MainContent = ({ setSelectedPaciente, setCurrentForm, currentForm }) => {
  const [paciente, setPaciente] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const [consultas, setConsultas] = useState([]);
  const consultasPerPage = 10;
  const [pageNumber, setPageNumber] = useState(0);

  // Chard 1
  const [citasHoy, setCitasHoy] = useState([]);
  const [selected, setSelected] = useState(false);
  const navigate = useNavigate();
  const [formulario, setFormulario] = useState({
    categoriaNm: "",
    horaFormateada: "",
    fechaCita: "",
    nombrePaciente: "",
    nombreDelPaciente: "",
    direccionPaciente: "",
    contactoPaciente: "",
    emailPaciente: "",
    notaCita: "",
    estatusCalendar: "",
    pacienteId: "",
  });

  // Modal
  const [showModal, setShowModal] = useState(false);
  const [selectedConsulta, setSelectedConsulta] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  // Modal Citas
  const [showCitasModal, setShowCitasModal] = useState(false);
  const [citas, setCitas] = useState([]);
  const [searchDate, setSearchDate] = useState("");

  // Paginación citas
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  // Cache
  const [cache, setCache] = useState({
    patients: null,
    consults: null,
    calendars: null,
  });
  const [lastUpdate, setLastUpdate] = useState(null);
  const [pacientesData, setPacientesData] = useState({
    cantidad: 0,
    porcentaje: 0,
  });
  const [consultasData, setConsultasData] = useState({
    cantidad: 0,
    porcentaje: 0,
  });
  const [consultasNew, setConsultasNew] = useState([]);
  const [citasData, setCitasData] = useState({ cantidad: 0, porcentaje: 0 });
  const [hasData, setHasData] = useState(null);
  const [hasDataReady, setHasDataReady] = useState(false);
  const [pendingAppointments, setPendingAppointments] = useState([]);
  const [Appointments, setAppointments] = useState([]);
   
  const [loading, setLoading] = useState(true);
  const [chartDataTwo, setChartDataTwo] = useState(null);
  // const [parseFechaCita, setParseFechaCita] = useState(null);
 
  
  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
      setHasDataReady(false);

      try {
        const dashboardRes = await medicGeekApi.get("/dashboard/cards");
        const appointmentsRes = await medicGeekApi.get("/calendars/detail");

        // Procesar data aquí
        const { data } = dashboardRes.data;

        if (data) {
          setPacientesData({
            cantidad: data.pacientes.cantidad.toLocaleString(),
            porcentaje: data.pacientes.porcentaje.toFixed(2),
          });

          setConsultasData({
            cantidad: data.consultas.cantidad.toLocaleString(),
            porcentaje: data.consultas.porcentaje.toFixed(2),
          });

          setCitasData({
            cantidad: data.citas.cantidad.toLocaleString(),
            porcentaje: data.citas.porcentaje.toFixed(2),
          });
        }

        const safeData = Array.isArray(appointmentsRes.data)
          ? appointmentsRes.data
          : [];
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const yyyy = today.getFullYear();
        const todayFormatted = `${dd}/${mm}/${yyyy}`;

        const filteredAppointments = safeData.filter((appointment) => {
          const fechaCita = appointment.fechaCita?.split(" ")[0];
          return fechaCita === todayFormatted;
        });

        const pendingAppointmentsOrdenadas =
         filteredAppointments
        .map((appointment) => {
          const {
            formattedDate,
            formattedHour,
            timestamp,
          } = parseFechaCita(
            appointment.fechaCita
          );

      return {
        id: appointment.calendarId,

        paciente: [
          appointment.patient?.pcteNom,
          appointment.patient?.pcteNom2,
          appointment.patient?.pcteApe1,
          appointment.patient?.pcteApe2,
        ]
          .filter(Boolean)
          .join(" ")
          .trim(),

        categoria:
          appointment.category?.categoryNm ?? "",

        fecha:
          appointment.fechaCita ?? "",

        formattedDate,
        formattedHour,

        // Lo usamos para ordenar
        timestamp,

        estatus:
          appointment.estatus ?? "",

        patient:
          appointment.patient,

        calendarId:
          appointment.calendarId,
      };
    })

    // ==========================================
    // ORDENAR POR FECHA Y HORA
    // ==========================================
    .sort(
      (a, b) =>
        a.timestamp - b.timestamp
    );


    setPendingAppointments(
      pendingAppointmentsOrdenadas
    );

        setHasData(filteredAppointments.length > 0);

        // 💥 Aquí indicas que ya tienes data lista para renderizar
        setHasDataReady(true);
      } catch (error) {
        console.error("Error al obtener datos:", error);
        setPacientesData({});
        setConsultasData({});
        setCitasData({});
        setPendingAppointments([]);
        setHasData(false);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);
  // Endpoint de las Cards y Citas

  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0"); // Meses empiezan desde 0
    const dd = String(today.getDate()).padStart(2, "0");
    setSearchDate(`${yyyy}-${mm}-${dd}`); // Formato yyyy-MM-dd
  }, []);

  useEffect(() => {
    const fetchConsultas = async () => {
      try {
        const response = await medicGeekApi.get("/consults/latest");
        setConsultas(response.data);
      } catch (error) {
        console.error("Error al obtener las consultas:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchConsultas();
  }, []);

  useEffect(() => {
    const fetchConsultas = async () => {
      try {
        const response = await medicGeekApi.get("/consults");
        setConsultasNew(response.data);
      } catch (error) {
        console.error("Error al obtener las consultas:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchConsultas();
  }, []);

  // Chard 1
  useEffect(() => {
    if (!Array.isArray(consultasNew) || consultasNew.length === 0) return;

    const monthNames = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];

    const consultasPorMes = {};
    const currentYear = new Date().getFullYear();

    // Inicializar todos los meses en 0
    monthNames.forEach((mes) => {
      consultasPorMes[mes] = 0;
    });

    consultasNew.forEach((consulta) => {
      const fechaStr = consulta.consultFec || consulta.fecha;
      if (!fechaStr) return;

      // Ejemplo formato: "03/07/2025 01:39 PM"
      const parts = fechaStr.split(" ")[0].split("/");

      if (parts.length < 3) return;

      const mesNumerico = parseInt(parts[1], 10);
      const anio = parseInt(parts[2], 10);

      if (anio !== currentYear) return;

      const mesNombre = monthNames[mesNumerico - 1];
      consultasPorMes[mesNombre]++;
    });

    const orderedLabels = monthNames;
    const orderedData = orderedLabels.map((name) => consultasPorMes[name]);

    setChartDataTwo({
      labels: orderedLabels,
      datasets: [
        {
          label: "Consultas por Mes",
          data: orderedData,
          backgroundColor: "rgb(63, 128, 234)",
          borderColor: "rgb(17, 113, 239)",
          borderWidth: 1,
          borderRadius: 8,
        },
      ],
    });
  }, [consultasNew]);

  const chartOptionsTwo = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      title: {
        display: true,
        text: "Consultas por Mes (Año actual)",
      },
    },
  };
  // Termina el grafico

  const displayedConsults = consultas.slice(
    pageNumber * consultasPerPage,
    (pageNumber + 1) * consultasPerPage
  );

  citasHoy.sort((a, b) => {
    const horaA = new Date(a.fechaCita).getHours();
    const horaB = new Date(b.fechaCita).getHours();
    return horaA - horaB;
  });

  const parseFechaCita = (dateTimeStr) => {
    if (!dateTimeStr || typeof dateTimeStr !== "string") {
      return {
        formattedDate: "",
        formattedHour: "",
        timestamp: 0,
      };
    }

    const [datePart, timePart, period] =
      dateTimeStr.trim().split(/\s+/);

    if (!datePart || !timePart || !period) {
      return {
        formattedDate: "",
        formattedHour: "",
        timestamp: 0,
      };
    }

    const [day, month, year] = datePart.split("/");

    let [hour, minute] = timePart
      .split(":")
      .map(Number);

    if (
      !day ||
      !month ||
      !year ||
      Number.isNaN(hour) ||
      Number.isNaN(minute)
    ) {
      return {
        formattedDate: "",
        formattedHour: "",
        timestamp: 0,
      };
    }

    // Convertir 12 horas -> 24 horas
    if (
      period.toUpperCase() === "PM" &&
      hour !== 12
    ) {
      hour += 12;
    }

    if (
      period.toUpperCase() === "AM" &&
      hour === 12
    ) {
      hour = 0;
    }

    const dateObject = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      hour,
      minute
    );

    const displayHour =
      dateObject.getHours() % 12 || 12;

    const displayMinute =
      String(dateObject.getMinutes()).padStart(2, "0");

    const displayPeriod =
      dateObject.getHours() >= 12
        ? "PM"
        : "AM";

    return {
      formattedDate:
        `${String(day).padStart(2, "0")}/` +
        `${String(month).padStart(2, "0")}/` +
        `${year}`,

      formattedHour:
        `${displayHour}:${displayMinute} ${displayPeriod}`,

      timestamp: dateObject.getTime(),
    };
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  const handleEnviarConsultaClick = async (cita) => {
    try {
      // console.log("Evento seleccionado:", cita);

      const pacienteId = cita.patient?.pcteId;

      if (!pacienteId) {
        console.error("No se encontró el ID del paciente en la cita");
        return;
      }

      const { patient, estatus, calendarId, category } = cita;
      const consultaCita = { ...patient, estatus, calendarId, category };

      // console.log(consultaCita);

      setSelectedPaciente(consultaCita);
      setCurrentForm("consultaForm");
      setSelected(true);

      navigate(`/patients/${pacienteId}/encounters/0`);
    } catch (error) {
      console.error("Error al cargar la última consulta:", error);
    }
  };

  const SkeletonCard = () => (
    <div className="col-lg-6 col-xl-3">
      <div className="card-stats mb-4 mb-xl-0 card text-start">
        <div className="card-body">
          <div className="row align-items-center">
            <div className="col">
              <span
                className="text-uppercase text-muted mb-0 card-title skeleton-placeholder"
                style={{
                  backgroundColor: "#e0e0e0",
                  height: "20px",
                  width: "100px",
                }}
              ></span>
              <span
                className="h5 font-weight-bold mb-0 skeleton-placeholder"
                style={{
                  backgroundColor: "#e0e0e0",
                  height: "30px",
                  width: "50px",
                }}
              ></span>
            </div>
            <div className="col-auto col">
              <div
                className="icon icon-shape text-white rounded-circle shadow d-flex align-items-center justify-content-center skeleton-placeholder"
                style={{
                  backgroundColor: "#e0e0e0",
                  width: "60px",
                  height: "60px",
                }}
              ></div>
            </div>
          </div>
          <p className="mt-3 mb-0 text-muted text-sm">
            <span
              className="skeleton-placeholder"
              style={{
                backgroundColor: "#e0e0e0",
                height: "20px",
                width: "150px",
              }}
            ></span>
          </p>
        </div>
      </div>
    </div>
  );

  const SkeletonAppointmentRow = () => (
    <tr>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "50px", width: "100%" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "50px", width: "100%" }}
        ></div>
      </td>
    </tr>
  );

  const SkeletonTableRow = () => (
    <tr>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "50px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "150px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "200px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "150px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "30px" }}
        ></div>
      </td>
    </tr>
  );

  const SkeletonLoader = ({
    width = "100%",
    height = "100%",
    borderRadius = "0.5rem",
  }) => {
    return (
      <div
        style={{
          width,
          height,
          backgroundColor: "#e0e0e0",
          borderRadius,
          animation: "pulse 1.5s infinite",
        }}
      />
    );
  };

  // Función para manejar la apertura del modal con la consulta seleccionada
  const handleViewDetail = (consulta) => {
    setSelectedConsulta(consulta); // Establece la consulta seleccionada
    setModalOpen(true); // Abre el modal
  };

  // Función para cerrar el modal
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  //  citas
  // Filtrar citas por fecha
  const filteredCitas = citas.filter((cita) => {
    const citaDate = cita.formattedDate.split(" ")[0]; // Extrae solo la fecha (dd/mm/yyyy)
    return citaDate === searchDate.split("-").reverse().join("/"); // Compara fecha seleccionada con formato invertido
  });

  // Calcular índices para la paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Obtener los elementos de la página actual
  const currentItems = filteredCitas.slice(indexOfFirstItem, indexOfLastItem);

  // Calcular número total de páginas
  const totalPages = Math.ceil(filteredCitas.length / itemsPerPage);

  // Manejar el cambio de página
  const handlePageChange = (pageIndex) => {
    if (pageIndex >= 1 && pageIndex <= totalPages) {
      setCurrentPage(pageIndex);
    }
  };

  const handleOpenCitasModal = async () => {
    const formatDate = (dateTimeStr) => {
      if (typeof dateTimeStr !== "string") {
        return { formattedDate: "", formattedHour: "", timestamp: 0 };
      }

      const [datePart, timePart, period] = dateTimeStr.split(" ");
      if (!datePart || !timePart || !period)
        return { formattedDate: "", formattedHour: "", timestamp: 0 };

      const [day, month, year] = datePart.split("/");
      let [hour, minute] = timePart.split(":");

      hour = parseInt(hour, 10);
      minute = parseInt(minute, 10);

      // Convertir hora AM/PM al formato 24 horas para usar en Date()
      if (period === "PM" && hour !== 12) {
        hour += 12;
      } else if (period === "AM" && hour === 12) {
        hour = 0;
      }

      // Crear un objeto Date usando los valores procesados
      const dateObject = new Date(year, month - 1, day, hour, minute);

      // Formatear la fecha y hora para mostrar
      const formattedDate = `${day.padStart(2, "0")}/${month.padStart(
        2,
        "0"
      )}/${year}`;
      const displayHour = dateObject.getHours() % 12 || 12; // Convertir a formato 12 horas
      const displayMinute = dateObject.getMinutes().toString().padStart(2, "0");
      const displayPeriod = dateObject.getHours() >= 12 ? "PM" : "AM";
      const formattedHour = `${displayHour}:${displayMinute} ${displayPeriod}`;

      // Crear un timestamp para ordenar las citas
      const timestamp = dateObject.getTime();

      return { formattedDate, formattedHour, timestamp };
    };

    try {
      const response = await medicGeekApi.get("/calendars/detail");
      const calendarData = response.data.map((paciente) => {
        const { formattedDate, formattedHour, timestamp } = formatDate(
          paciente.fechaCita
        );
        return {
          ...paciente,
          formattedDate,
          formattedHour,
          timestamp, // Guardar timestamp para ordenar
        };
      });

      // Ordenar las citas por el timestamp
      calendarData.sort((a, b) => a.timestamp - b.timestamp);

      setCitas(calendarData);
      setShowCitasModal(true);
    } catch (error) {
      console.error("Error al obtener citas:", error);
    }
  };

  const handleCloseCitasModal = () => {
    setShowCitasModal(false);
  };

  const handleSearchDate = (event) => {
    setSearchDate(event.target.value);
  };

  const handlePrintPDF = () => {
      const doc = new jsPDF();

      // Información estática para el PDF
      const header = "Listado de Citas Pendientes";
      const currentDate = dayjs().format("DD/MM/YYYY");

      // Encabezado del documento
      doc.setFontSize(18);
      doc.text(header, 14, 22);

      // Fecha actual
      doc.setFontSize(12);
      doc.text(`Fecha: ${currentDate}`, 14, 30);

      // Crear la tabla con las citas filtradas
      const citasData = filteredCitas.map((cita) => [
        // Manejar null para los datos del paciente
        [
          cita.patient?.pcteNom || "",
          cita.patient?.pcteNom2 || "",
          cita.patient?.pcteApe1 || "",
          cita.patient?.pcteApe2 || "",
        ]
          .filter((item) => item) // Filtra valores vacíos
          .join(" "), // Une los nombres con espacios

        // Manejar null para la fecha y hora
        `${cita.formattedDate || "Sin fecha"} ${
          cita.formattedHour || "Sin hora"
        }`,

        // Manejar null para la categoría
        cita.patient?.pcteCel || cita.patient?.pcteTel,
      ]);

      // Añadir la tabla al PDF
      doc.autoTable({
        startY: 40, // Posición inicial de la tabla
        head: [["Paciente", "Fecha", "Teléfono"]], // Encabezados de la tabla
        body: citasData, // Datos de las citas
        theme: "grid",
        styles: { fontSize: 10 },
      });

      // Agregar número total de páginas
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.text(
          14,
          doc.internal.pageSize.height - 10,
          `Página ${i} de ${pageCount}`
        );
      }

      // Descargar el PDF
      doc.save("listado-citas.pdf");
    };

  const handleNoAsistio = async (paciente) => {
    const confirmacion = window.confirm(
      `¿El paciente ${paciente.paciente} no asistió a la cita?`
    );

    if (!confirmacion) return;

    try {
      await medicGeekApi.patch(
        `/calendars/${paciente.calendarId}`,
        {
          estatus: "No Asistio",
        }
      );

      // Actualizar dashboard
      setPendingAppointments((prev) =>
        prev.map((item) =>
          item.calendarId === paciente.calendarId
            ? { ...item, estatus: "No Asistio" }
            : item
        )
      );

      // Actualizar modal
      setAppointments((prev) =>
        prev.map((item) =>
          item.calendarId === paciente.calendarId
            ? { ...item, estatus: "No Asistio" }
            : item
        )
      );

      alert("Estatus actualizado correctamente.");
    } catch (error) {
      console.error(error);
      alert("Error al actualizar el estatus.");
    }
  };

  const getPlainText = (html = "") => {
    if (!html) return "";

    const div = document.createElement("div");
    div.innerHTML = html;

    return (div.textContent || div.innerText || "")
      .replace(/\s+/g, " ")
      .trim();
  };

  

  return (
    <div className="dashboard-container">
      <div className="">
        <div style={{ paddingBottom: "5rem" }}>
          <div
            className="h-100"
            style={{
              minHeight: "20rem",
              background: "linear-gradient(135deg, #2563eb, #3b82f6)",
              borderRadius: "0 0 30px 30px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            }}
          >
            <div className="p-2 mx-4 ">
              <div className="d-flex justify-content-start pt-2 pb-4"></div>
              <div className="row">
                {loading || !hasDataReady ? (
                  <>
                    <SkeletonCard />
                    <SkeletonCard />
                    <SkeletonCard />
                    <SkeletonCard />
                  </>
                ) : (
                  <>
                    {/* BIENVENIDA */}
                    <div className="col-xl-3 col-lg-6 col-md-6 mb-4">
                      <div className="dashboard-card h-100">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h6 className="text-primary fw-bold">
                              Bienvenido 👋
                            </h6>

                            <small className="dashboard-text-muted">
                              Zalud Clinical Dashboard
                            </small>
                          </div>

                          <img src={MedicineSVG} style={{ width: 60 }} />
                        </div>
                      </div>
                    </div>

                                        {/* PACIENTES */}
                    <div className="col-12 col-sm-6 col-xl-3 mb-4">
                      <div className="dashboard-card h-100">
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <small className="dashboard-card-title">Pacientes</small>

                            <h2 className="dashboard-card-number text-success">
                              {pacientesData?.cantidad || 0}
                            </h2>

                            <div className="dashboard-card-growth text-success">
                              <i className="bi bi-graph-up-arrow pe-1"></i>
                              ↑ {pacientesData?.porcentaje || 0}% esta semana
                            </div>
                          </div>

                          <div className="dashboard-icon danger">
                            <i className="bi bi-person-plus"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* CONSULTAS */}
                    <div className="col-12 col-sm-6 col-xl-3 mb-4">
                      <div className="dashboard-card h-100">
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <small className="dashboard-card-title">Consultas</small>

                            <h2 className="dashboard-card-number text-warning">
                              {consultasData?.cantidad || 0}
                            </h2>

                            <div className="dashboard-card-growth text-success">
                              <i className="bi bi-graph-up-arrow pe-1"></i>
                              ↑ {consultasData?.porcentaje || 0}% esta semana
                            </div>
                          </div>

                          <div className="dashboard-icon warning">
                            <i className="bi bi-clipboard2-pulse"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* CITAS */}
                    <div className="col-12 col-sm-6 col-xl-3 mb-4">
                      <div className="dashboard-card h-100">
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <small className="dashboard-card-title">Citas</small>

                            <h2 className="dashboard-card-number text-info">
                              {citasData?.cantidad || 0}
                            </h2>

                            <div className="dashboard-card-growth text-success">
                              <i className="bi bi-graph-up-arrow pe-1"></i>
                              ↑ {citasData?.porcentaje || 0}% esta semana
                            </div>
                          </div>

                          <div className="dashboard-icon info">
                            <i className="bi bi-calendar-check"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                  </>
                )}
              </div>
            </div>
          </div>
          {/* Cards */}

          <div className="row px-4 mt-n5 gy-4"
          style={{
            position: "relative",
            top: "-5rem",
          }}
          >
            {/* PANEL CITAS */}
            <div className="col-12 col-xl-5">
              <div className="dashboard-panel">

                {/* HEADER */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="fs-5 text-secondary">
                    <i className="bi bi-calendar-range px-2"></i>
                    <label>Citas Pendientes</label>
                  </div>

                  <button
                    className="btn btn-light border border-success-subtle text-success px-4"
                    onClick={handleOpenCitasModal}
                  >
                    Listado
                  </button>
                </div>

                {/* LEYENDA */}
                <div className="text-end mb-3">
                  <label className="fw-bold text-decoration-underline">
                    Leyenda
                  </label>

                  <div className="d-flex justify-content-end gap-2 mt-1">
                    <span className="badge bg-success">Activa</span>
                    <span className="badge bg-primary">Completada</span>
                    <span className="badge bg-dark">No Asistió</span>
                    <span className="badge bg-danger">Cancelada</span>
                  </div>
                </div>

                {/* TABLA */}
                <div
                  style={{
                    maxHeight: "29rem",
                    overflowY: "auto",
                  }}
                >
                  <table className="table align-middle">
                    <thead>
                      <tr>
                        <th>Información</th>
                        <th></th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading || !hasDataReady ? (
                        Array.from({ length: 5 }).map((_, index) => (
                          <SkeletonAppointmentRow key={index} />
                        ))
                      ) : Array.isArray(pendingAppointments) &&
                        pendingAppointments.length > 0 ? (
                        pendingAppointments.map((paciente) => (
                          <tr
                            key={paciente.id}
                            className={
                              paciente.estatus === "Completada"
                                ? "table-secondary"
                                : paciente.estatus === "Cancelada"
                                ? "table-danger"
                                : paciente.estatus === "No Asistio"
                                ? "table-danger"
                                : ""
                            }
                            style={{
                              opacity:
                                paciente.estatus === "Cancelada" ||
                                paciente.estatus === "Completada" ||
                                paciente.estatus === "No Asistio"
                                  ? 0.6
                                  : 1,
                            }}
                          >
                            <td>
                              <div className="d-flex flex-column">
                                <span className="text-decoration-underline">
                                  {paciente.paciente}
                                </span>

                                <span>{paciente.categoria}</span>

                                <strong>
                                 {paciente.formattedHour}
                                </strong>
                              </div>
                            </td>

                          <td className="text-end">
                            <div className="d-flex flex-column gap-2">

                              <button
                                type="button"
                                style={{
                                  minWidth: "12rem",
                                  height: "2.8rem",
                                }}
                                className={`btn fw-semibold ${
                                  paciente.estatus === "Completada"
                                    ? "btn-primary"
                                    : paciente.estatus === "Cancelada"
                                    ? "btn-danger"
                                    : paciente.estatus === "No Asistio"
                                    ? "btn-dark"
                                    : "btn-success"
                                }`}
                                disabled={
                                  paciente.estatus === "Cancelada" ||
                                  paciente.estatus === "Completada" ||
                                  paciente.estatus === "No Asistio"
                                }
                                onClick={() =>
                                  handleEnviarConsultaClick(paciente)
                                }
                              >
                                {paciente.estatus === "Completada" ? (
                                  <>
                                    <i className="bi bi-check-circle-fill pe-2"></i>
                                    Cita Completada
                                  </>
                                ) : paciente.estatus === "Cancelada" ? (
                                  <>
                                    <i className="bi bi-x-circle-fill pe-2"></i>
                                    Cita Cancelada
                                  </>
                                ) : paciente.estatus === "No Asistio" ? (
                                  <>
                                    <i className="bi bi-person-x-fill pe-2"></i>
                                    No Asistió
                                  </>
                                ) : (
                                  <>
                                    <i className="bi bi-arrow-right-circle-fill pe-2"></i>
                                    Enviar a Consulta
                                  </>
                                )}
                              </button>

                              {paciente.estatus !== "Cancelada" &&
                                paciente.estatus !== "Completada" &&
                                paciente.estatus !== "No Asistio" && (
                                  <button
                                    type="button"
                                    className="btn btn-dark fw-semibold"
                                    onClick={() => handleNoAsistio(paciente)}
                                  >
                                    <i className="bi bi-person-x-fill pe-2"></i>
                                    No Asistió
                                  </button>
                                )}
                            </div>
                          </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="2"
                            className="text-center text-muted py-4"
                          >
                            No hay citas pendientes
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Modal
              isOpen={showCitasModal}
              toggle={handleCloseCitasModal}
              size="xl"
              centered
              className="dashboard-modal"
            >
              {/* HEADER */}
              <ModalHeader toggle={handleCloseCitasModal}>
                <div className="d-flex align-items-center gap-2">
                  <i className="bi bi-calendar2-week text-primary"></i>
                  <span>Citas Agendadas</span>
                </div>
              </ModalHeader>

              {/* BODY */}
              <ModalBody>

                {/* FILTRO */}
                <div className="appointments-filter mb-4">
                  <div className="appointments-filter-content">

                    <div>
                      <h6 className="mb-1 fw-bold">
                        Buscar por Fecha
                      </h6>

                      <small className="text-muted">
                        Filtra las citas según la fecha seleccionada
                      </small>
                    </div>

                    <div className="appointments-date-container">
                      <input
                        type="date"
                        className="form-control appointments-date-input"
                        value={searchDate}
                        onChange={handleSearchDate}
                      />
                    </div>

                  </div>
                </div>

                {/* TABLA */}
                <div className="table-responsive">
                  <table className="table table-modern align-middle">
                    <thead>
                      <tr>
                        <th>Paciente</th>
                        <th>Hora</th>
                        <th>Teléfono</th>
                        <th className="text-center">Estado</th>
                        <th className="text-center">Acción</th>
                      </tr>
                    </thead>

                    <tbody>
                      {currentItems.map((paciente) => (
                        <tr key={paciente.id}>

                          {/* PACIENTE */}
                          <td>
                            <div className="d-flex align-items-center gap-3">

                              <div className="appointment-avatar">
                                <i className="bi bi-person"></i>
                              </div>

                              <div>
                                <div className="fw-semibold text-dark">
                                  {paciente.patient.pcteNom}{" "}
                                  {paciente.patient.pcteNom2}{" "}
                                  {paciente.patient.pcteApe1}{" "}
                                  {paciente.patient.pcteApe2}
                                </div>

                                <small className="text-muted">
                                  ID #{paciente.id}
                                </small>
                              </div>

                            </div>
                          </td>

                          {/* HORA */}
                          <td>
                            <span className="appointment-time">
                              <i className="bi bi-clock me-2"></i>
                              {paciente.formattedHour}
                            </span>
                          </td>

                          {/* TELEFONO */}
                          <td>
                            <span className="text-secondary fw-medium">
                              {paciente.patient.pcteCel}
                            </span>
                          </td>

                          {/* ESTADO */}
                          <td className="text-center">
                            <span
                              className={`appointment-status
                                ${
                                    paciente.estatus === "Completada"
                                    ? "status-completed"
                                    : paciente.estatus === "Cancelada"
                                    ? "status-cancelled"
                                    : "status-active"
                                }
                              `}
                            >
                              {paciente.estatus || "Activa"}
                            </span>
                          </td>

                          {/* ACCION */}
                          <td className="text-center">
                            <div className="d-flex justify-content-center gap-2">

                              <button
                                type="button"
                                className={`
                                  appointment-action-btn
                                  ${
                                    paciente.estatus === "Completada"
                                      ? "btn-completed"
                                      : paciente.estatus === "Cancelada"
                                      ? "btn-cancelled"
                                      : paciente.estatus === "No Asistio"
                                      ? "btn-dark"
                                      : "btn-active"
                                  }
                                `}
                                disabled={
                                  paciente.estatus === "Cancelada" ||
                                  paciente.estatus === "Completada" ||
                                  paciente.estatus === "No Asistio"
                                }
                                onClick={() =>
                                  handleEnviarConsultaClick(paciente)
                                }
                              >
                                {paciente.estatus === "Completada" ? (
                                  <>
                                    <i className="bi bi-check-circle-fill"></i>
                                    Completada
                                  </>
                                ) : paciente.estatus === "Cancelada" ? (
                                  <>
                                    <i className="bi bi-x-circle-fill"></i>
                                    Cancelada
                                  </>
                                ) : paciente.estatus === "No Asistio" ? (
                                  <>
                                    <i className="bi bi-person-x-fill"></i>
                                    No Asistió
                                  </>
                                ) : (
                                  <>
                                    <i className="bi bi-arrow-right-circle-fill"></i>
                                    Enviar a Consulta
                                  </>
                                )}
                              </button>

                              {paciente.estatus !== "Cancelada" &&
                                paciente.estatus !== "Completada" &&
                                paciente.estatus !== "No Asistio" && (
                                  <button
                                    type="button"
                                    className="btn btn-dark"
                                    onClick={() => handleNoAsistio(paciente)}
                                  >
                                    <i className="bi bi-person-x-fill"></i>
                                  </button>
                                )}

                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* PAGINACION */}
                {!showForm && (
                  <div className="appointments-pagination">

                    <nav>
                      <ul className="pagination modern-pagination align-items-center">

                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              handlePageChange(currentPage - 1)
                            }
                          >
                            <i className="bi bi-chevron-left"></i>
                          </button>
                        </li>

                        {Array.from(
                          { length: totalPages },
                          (_, index) => (
                            <li
                              key={index}
                              className={`page-item ${
                                currentPage === index + 1
                                  ? "active"
                                  : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() =>
                                  handlePageChange(index + 1)
                                }
                              >
                                {index + 1}
                              </button>
                            </li>
                          )
                        )}

                        <li
                          className={`page-item ${
                            currentPage === totalPages
                              ? "disabled"
                              : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              handlePageChange(currentPage + 1)
                            }
                          >
                            <i className="bi bi-chevron-right"></i>
                          </button>
                        </li>

                      </ul>
                    </nav>

                  </div>
                )}

              </ModalBody>

              {/* FOOTER */}
              <ModalFooter className="border-0 px-4 pb-4">

                <Button
                  color="primary"
                  className="rounded-pill px-4 py-2"
                  onClick={handlePrintPDF}
                >
                  <i className="bi bi-printer me-2"></i>
                  Imprimir
                </Button>

                <Button
                  color="secondary"
                  className="rounded-pill px-4 py-2"
                  onClick={handleCloseCitasModal}
                >
                  Cerrar
                </Button>

              </ModalFooter>
            </Modal>
            {/* Citas 2*/}

            {/* PANEL CHART */}
            <div className="col-12 col-xl-7">
              <div className="dashboard-panel">

                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    minHeight: "28rem",
                  }}
                >
                  {!chartDataTwo ||
                  Object.keys(chartDataTwo).length === 0 ? (
                    <SkeletonLoader width="100%" height="28rem" />
                  ) : (
                    <Bar
                      data={chartDataTwo}
                      options={chartOptionsTwo}
                    />
                  )}
                </div>

              </div>
            </div>
          </div>
          {/* Citas & Chards */}

          {/* ============================= */}
          {/* LISTADO ÚLTIMAS CONSULTAS */}
          {/* ============================= */}

          <div className="dashboard-panel mt-4 mx-4"
           style={{
            position: "relative",
            top: "-5rem",
          }}>
            {/* HEADER */}
            <div className="dashboard-panel-header">
              <div>
                <h5 className="dashboard-title">
                  <i className="bi bi-journal-medical me-2"></i>
                  Últimas Consultas
                </h5>

                <small className="dashboard-subtitle">
                  Historial reciente de consultas registradas
                </small>
              </div>
            </div>

            {/* TABLA */}
            <div className="table-responsive px-3 pb-3">
              <table className="table table-modern align-middle">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Paciente</th>
                    <th>Dirección</th>
                    <th>Fecha</th>
                    <th>Motivo</th>
                    <th className="text-center">Acción</th>
                  </tr>
                </thead>

                <tbody>
                  {loading
                    ? Array.from({ length: 10 }).map((_, index) => (
                        <SkeletonTableRow key={index} />
                      ))
                    : [...consultas]
                        .sort((a, b) => b.id - a.id)
                        .map((consulta) => (
                          <tr key={consulta.id}>
                            {/* ID */}
                            <td>
                              <span className="badge bg-primary-subtle text-primary fw-semibold px-3 py-2">
                                #{consulta.id}
                              </span>
                            </td>

                            {/* PACIENTE */}
                            <td>
                              <div className="fw-semibold text-dark">
                                {consulta.paciente}
                              </div>
                            </td>

                            {/* DIRECCIÓN */}
                            <td
                              title={consulta.direccion}
                              style={{ maxWidth: "200px" }}
                            >
                               <span className="text-secondary">
                                {consulta.direccion?.length > 10
                                  ? `${consulta.direccion.slice(0, 10)}...`
                                  : consulta.direccion}
                              </span>
                            </td>

                            {/* FECHA */}
                            <td>
                              <div className="fw-medium">
                                {consulta.fecha}
                              </div>
                            </td>

                            {/* MOTIVO */}
                           <td
                              title={getPlainText(consulta.motivo)}
                              style={{ maxWidth: "200px" }}
                            >
                              <span className="text-secondary">
                                {getPlainText(consulta.motivo).length > 30
                                  ? `${getPlainText(consulta.motivo).slice(0, 30)}...`
                                  : getPlainText(consulta.motivo)}
                              </span>
                            </td>

                            {/* ACCIÓN */}
                            <td className="text-center">
                              <button
                                type="button"
                                className="dashboard-action-btn"
                                title="Ver detalle de la consulta"
                                onClick={() => handleViewDetail(consulta)}
                              >
                                <i className="bi bi-folder2-open"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* ============================= */}
          {/* MODAL DETALLE CONSULTA */}
          {/* ============================= */}

          <Modal
            isOpen={modalOpen}
            toggle={toggleModal}
            size="lg"
            centered
            className="dashboard-modal"
          >
            <ModalHeader toggle={toggleModal}>
              <div className="d-flex align-items-center gap-2">
                <i className="bi bi-file-earmark-medical text-primary"></i>
                <span>Detalle de Consulta</span>
              </div>
            </ModalHeader>

            <ModalBody>
              {selectedConsulta && (
                <div>
                  {/* HEADER PACIENTE */}
                  <div className="consultation-header">
                    <div className="consultation-avatar">
                      <img
                        alt="Paciente"
                        src="https://www.shareicon.net/data/128x128/2016/08/05/806962_user_512x512.png"
                      />
                    </div>

                    <div className="consultation-info">
                      <div className="consultation-row">
                        <span className="label">Expediente:</span>
                        <span className="value">
                          #{selectedConsulta.id}
                        </span>
                      </div>

                      <div className="consultation-row">
                        <span className="label">Fecha:</span>
                        <span className="value">
                          {selectedConsulta.fecha}
                        </span>
                      </div>

                      <div className="consultation-row">
                        <span className="label">Paciente:</span>
                        <span className="value">
                          {selectedConsulta.paciente || ""}
                        </span>
                      </div>

                      <div className="consultation-row">
                        <span className="label">Dirección:</span>
                        <span className="value">
                          {selectedConsulta.direccion || ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* CONTENIDO */}
                  <div className="consultation-content mt-4">

                   <div className="consultation-card">
                    <h6>Motivo de Consulta</h6>

                    {selectedConsulta.motivo ? (
                      <div
                        className="history-rich-content"
                        dangerouslySetInnerHTML={{
                          __html: selectedConsulta.motivo,
                        }}
                      />
                    ) : (
                      <p>SIN MOTIVO DE CONSULTA</p>
                    )}
                  </div>


                  <div className="consultation-card">
                    <h6>Observación</h6>

                    {selectedConsulta.observacion ? (
                      <div
                        className="history-rich-content"
                        dangerouslySetInnerHTML={{
                          __html: selectedConsulta.observacion,
                        }}
                      />
                    ) : (
                      <p>SIN OBSERVACIÓN</p>
                    )}
                  </div>


                  <div className="consultation-grid">

                    <div className="consultation-card">
                      <h6>Tipo Diagnóstico</h6>

                      <p>
                        {selectedConsulta.diagnostico ||
                          "SIN DIAGNÓSTICO"}
                      </p>
                    </div>


                    <div className="consultation-card">
                      <h6>Clasificación</h6>

                      <p>
                        {selectedConsulta.clasificacionDiagnostico ||
                          "SIN CLASIFICACIÓN"}
                      </p>
                    </div>


                    <div className="consultation-card">
                      <h6>CIE-10</h6>

                      <p>
                        {selectedConsulta.cie10 ||
                          "SIN ENFERMEDAD"}
                      </p>
                    </div>


                    <div className="consultation-card">
                      <h6>Estudio Gabinete</h6>

                      {selectedConsulta.estudioGabinete ? (
                        <div
                          className="history-rich-content"
                          dangerouslySetInnerHTML={{
                            __html: selectedConsulta.estudioGabinete,
                          }}
                        />
                      ) : (
                        <p>SIN ESTUDIO</p>
                      )}
                    </div>


                    <div className="consultation-card">
                      <h6>Resultado Laboratorio</h6>

                      {selectedConsulta.resultadoLaboratorio ? (
                        <div
                          className="history-rich-content"
                          dangerouslySetInnerHTML={{
                            __html: selectedConsulta.resultadoLaboratorio,
                          }}
                        />
                      ) : (
                        <p>SIN RESULTADO</p>
                      )}
                    </div>


                    </div>
                  </div>
                </div>
              )}
            </ModalBody>

            <ModalFooter>
              <Button
                color="secondary"
                className="rounded-pill px-4"
                onClick={toggleModal}
              >
                Cerrar
              </Button>
            </ModalFooter>
          </Modal>

        </div>
        {currentForm === "consultaForm" &&
          selected &&
          paciente &&
          formulario && (
            <div className="main-content">
              <ConsultaForm
                onCloseForm={handleCloseForm}
                paciente={paciente}
                formulario={formulario}
                setCurrentForm={setCurrentForm}
              />
            </div>
          )}
      </div>
    </div>
  );
};

export default MainContent;
